import { render } from "./ProductRegistrationRegister.vue?vue&type=template&id=7d6bf7ec"
import script from "./ProductRegistrationRegister.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__